// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from './UserInfoCell'
import { UserLastLoginCell } from './UserLastLoginCell'
import { UserTwoStepsCell } from './UserTwoStepsCell'
import { UserActionsCell } from './UserActionsCell'
import { UserSelectionCell } from './UserSelectionCell'
import { UserCustomHeader } from './UserCustomHeader'
import { UserSelectionHeader } from './UserSelectionHeader'
import { User } from '../../core/_models'
import doctorTypes from '../../data/DoctorTypes'
import moment from 'moment'
import { Badge } from 'react-bootstrap'
import _ from 'lodash'

export const sections = [
  {
    label: 'Dashboard',
    value: 'dashboard'
  },
  {
    label: 'รายงาน',
    value: 'report'
  },
  {
    label: 'จัดการรักษา',
    value: 'treatment'
  },
  {
    label: 'คนไข้',
    value: 'patient'
  },
  {
    label: 'นัดหมาย',
    value: 'booking'
  },
  {
    label: 'ขายสินค้า',
    value: 'product'
  },
  {
    label: 'CRM',
    value: 'crm'
  },
  {
    label: 'ตารางลงตรวจแพทย์',
    value: 'doctor_schedule'
  },
  {
    label: 'ห้องแล็บ',
    value: 'lab'
  },
  {
    label: 'แบบฟอร์ม',
    value: 'medical_form'
  },
  {
    label: 'รายรับ',
    value: 'accounting_income'
  },
  {
    label: 'รายจ่าย',
    value: 'accounting_expense'
  },
  {
    label: 'การบัญชี',
    value: 'accounting_general'
  },
  {
    label: 'การเงิน',
    value: 'accounting_finance'
  },
  {
    label: 'คลังสินค้า',
    value: 'inventory'
  },
  {
    label: 'ทรัพย์สิน',
    value: 'asset'
  },
  {
    label: 'จัดการระบบ',
    value: 'setting'
  },

  {
    label: 'Line OA',
    value: 'line_oa'
  },
]

export const permissions = [
  {
    label: 'ดู Dashboard',
    value: 'view_dashboard',
    section: 'dashboard'
  },

  {
    label: 'ดูรายงานเคลม/โอน/ปรับปรุง/ค้าง',
    value: 'view_claim_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานขายสินค้า',
    value: 'view_product_report',
    section: 'report'
  },
  {
    label: 'ดูรายงาน ศล.ร้าน',
    value: 'view_tf_report',
    section: 'report'
  },
  {
    label: 'ดูรายงาน ศล.หมอ',
    value: 'view_df_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานสรุปรายการรักษา',
    value: 'view_treatment_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานยกเลิกใบเสร็จพร้อมเหตุผล',
    value: 'view_canceled_receipt_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานคนไข้',
    value: 'view_patient_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานสรุปรายการรักษาแยกหมวดการรักษา',
    value: 'view_treatment_by_cat_report',
    section: 'report'
  },
  {
    label: 'ดูรายงาน  Hi Touch',
    value: 'view_hi_touch_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานเงินฝากคงเหลือ',
    value: 'view_wallet_report',
    section: 'report'
  },
  {
    label: 'ดูรายงานประมาณการรายได้ ทันตแพทย์',
    value: 'view_income_report',
    section: 'report'
  },

  {
    label: 'ดูรายงานคนไข้ On Plan',
    value: 'view_on_plan_report',
    section: 'report'
  },
  {
    label: 'ดูข้อมูลจัดการรักษา',
    value: 'view_treatment',
    section: 'treatment'
  },
  // {
  //   label: 'แก้ไขข้อมูลจัดการรักษา',
  //   value: 'edit_treatment',
  //   section: 'treatment'
  // },
  {
    label: 'ยกเลิกใบเสร็จ',
    value: 'cancel_receipt',
    section: 'treatment'
  },
  {
    label: 'Reprint ใบเสร็จต้นฉบับ',
    value: 'reprint_receipt',
    section: 'treatment'
  },
  {
    label: 'ดูข้อมูลคนไข้',
    value: 'view_patient',
    section: 'patient'
  },
  {
    label: 'แก้ไขข้อมูลคนไข้',
    value: 'edit_patient',
    section: 'patient'
  },

  {
    label: 'ดูตารางนัดหมาย',
    value: 'view_schedule',
    section: 'booking'
  },
  {
    label: 'เพิ่ม/แก้ไขนัดหมาย',
    value: 'edit_schedule',
    section: 'booking'
  },
  {
    label: 'ดูข้อมูลนัดหมาย',
    value: 'view_booking',
    section: 'booking'
  },
  {
    label: 'แก้ไขสถานะนัดหมาย',
    value: 'edit_booking',
    section: 'booking'
  },

  {
    label: 'ขายสินค้า',
    value: 'edit_product',
    section: 'product'
  },
  {
    label: 'ดูข้อมูล CRM',
    value: 'view_crm',
    section: 'crm'
  },
  {
    label: 'เปลี่ยนสถานะ CRM',
    value: 'edit_crm',
    section: 'crm'
  },
  {
    label: 'ดูตารางลงตรวจแพทย์',
    value: 'view_doctor_schedule',
    section: 'doctor_schedule'
  },
  {
    label: 'แก้ไขตารางลงตรวจแพทย์',
    value: 'edit_doctor_schedule',
    section: 'doctor_schedule'
  },
  {
    label: 'ดูข้อมูล Lab',
    value: 'view_lab',
    section: 'lab'
  },
  {
    label: 'แก้ไขข้อมูล Lab',
    value: 'edit_lab',
    section: 'lab'
  },
  {
    label: 'ดูรายงาน Lab สาขา',
    value: 'view_lab_report_branch',
    section: 'lab'
  },
  {
    label: 'ดูรายงาน Lab บัญชี',
    value: 'view_lab_report_account',
    section: 'lab'
  },
  {
    label: 'ดูรายงาน Lab แพทย์',
    value: 'view_lab_report_doctor',
    section: 'lab'
  },
  {
    label: 'ดู/เพิ่มแบบฟอร์ม',
    value: 'view_medical_form',
    section: 'medical_form'
  },
  {
    label: 'ดู/เพิ่มข้อมูลบัญชี',
    value: 'view_accounting',
    section: 'accounting_general'
  },
  {
    label: 'นำเข้าเอกสาร - สร้าง',
    value: 'accounting_import_document_create',
    section: 'accounting_income'
  },
  {
    label: 'ภาพรวมรายรับ - ดู',
    value: 'accounting_income_overview_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสนอราคา - ดู',
    value: 'accounting_quotation_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสนอราคา - สร้าง',
    value: 'accounting_quotation_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสนอราคา - แก้ไข',
    value: 'accounting_quotation_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบรับเงินมัดจำ - ดู',
    value: 'accounting_deposit_receipt_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบรับเงินมัดจำ - สร้าง',
    value: 'accounting_deposit_receipt_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบรับเงินมัดจำ - แก้ไข',
    value: 'accounting_deposit_receipt_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบแจ้งหนี้ - ดู',
    value: 'accounting_invoice_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบแจ้งหนี้ - สร้าง',
    value: 'accounting_invoice_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบแจ้งหนี้ - แก้ไข',
    value: 'accounting_invoice_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสร็จรับเงิน - ดู',
    value: 'accounting_receipt_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสร็จรับเงิน - สร้าง',
    value: 'accounting_receipt_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบเสร็จรับเงิน - แก้ไข',
    value: 'accounting_receipt_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบกำกับภาษีขาย - ดู',
    value: 'accounting_sales_tax_invoice_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบกำกับภาษีขาย - สร้าง',
    value: 'accounting_sales_tax_invoice_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบกำกับภาษีขาย - แก้ไข',
    value: 'accounting_sales_tax_invoice_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบลดหนี้ - ดู',
    value: 'accounting_credit_note_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบลดหนี้ - สร้าง',
    value: 'accounting_credit_note_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบลดหนี้ - แก้ไข',
    value: 'accounting_credit_note_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบเพิ่มหนี้ - ดู',
    value: 'accounting_debit_note_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบเพิ่มหนี้ - สร้าง',
    value: 'accounting_debit_note_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบเพิ่มหนี้ - แก้ไข',
    value: 'accounting_debit_note_edit',
    section: 'accounting_income'
  },
  {
    label: 'ใบวางบิล - ดู',
    value: 'accounting_billing_note_view',
    section: 'accounting_income'
  },
  {
    label: 'ใบวางบิล - สร้าง',
    value: 'accounting_billing_note_create',
    section: 'accounting_income'
  },
  {
    label: 'ใบวางบิล - แก้ไข',
    value: 'accounting_billing_note_edit',
    section: 'accounting_income'
  },
  {
    label: 'ภาพรวมรายจ่าย - ดู',
    value: 'accounting_expense_overview_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - ดู',
    value: 'accounting_purchase_request_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - สร้าง',
    value: 'accounting_purchase_request_create',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - แก้ไข',
    value: 'accounting_purchase_request_edit',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - อนุมัติ',
    value: 'accounting_purchase_request_approve',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - ลบ',
    value: 'accounting_purchase_request_delete',
    section: 'accounting_expense'
  },
  {
    label: 'ใบขอสั่งซื้อ - ยกเลิกเอกสาร',
    value: 'cancel_expense_request_purchase_order_document',
    section: 'accounting_expense'
  },
  {
    label: 'ใบสั่งซื้อ - ดู',
    value: 'accounting_purchase_order_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบสั่งซื้อ - สร้าง',
    value: 'accounting_purchase_order_create',
    section: 'accounting_expense'
  },
  {
    label: 'ใบสั่งซื้อ - แก้ไข',
    value: 'accounting_purchase_order_edit',
    section: 'accounting_expense'
  },
  {
    label: 'ใบสั่งซื้อ - อนุมัติ',
    value: 'accounting_purchase_order_approve',
    section: 'accounting_expense'
  },
  {
    label: 'ใบสั่งซื้อ - ลบ',
    value: 'accounting_purchase_order_delete',
    section: 'accounting_expense'
  },
  {
    label: 'ใบจ่ายเงินมัดจำ - ดู',
    value: 'accounting_deposit_payment_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบจ่ายเงินมัดจำ - สร้าง',
    value: 'accounting_deposit_payment_create',
    section: 'accounting_expense'
  },
  {
    label: 'ใบจ่ายเงินมัดจำ - แก้ไข',
    value: 'accounting_deposit_payment_edit',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกซื้อสินค้า - ดู',
    value: 'accounting_purchase_record_view',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกซื้อสินค้า - สร้าง',
    value: 'accounting_purchase_record_create',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกซื้อสินค้า - แก้ไข',
    value: 'accounting_purchase_record_edit',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกค่าใช้จ่าย - ดู',
    value: 'accounting_expense_record_view',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกค่าใช้จ่าย - สร้าง',
    value: 'accounting_expense_record_create',
    section: 'accounting_expense'
  },
  {
    label: 'บันทึกค่าใช้จ่าย - แก้ไข',
    value: 'accounting_expense_record_edit',
    section: 'accounting_expense'
  },
  {
    label: 'ใบกำกับภาษีซื้อ - ดู',
    value: 'accounting_purchase_tax_invoice_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบกำกับภาษีซื้อ - สร้าง',
    value: 'accounting_purchase_tax_invoice_create',
    section: 'accounting_expense'
  },
  {
    label: 'ใบกำกับภาษีซื้อ - แก้ไข',
    value: 'accounting_purchase_tax_invoice_edit',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบลดหนี้ - ดู',
    value: 'accounting_receive_credit_note_view',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบลดหนี้ - สร้าง',
    value: 'accounting_receive_credit_note_create',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบลดหนี้ - แก้ไข',
    value: 'accounting_receive_credit_note_edit',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบเพิ่มหนี้ - ดู',
    value: 'accounting_receive_debit_note_view',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบเพิ่มหนี้ - สร้าง',
    value: 'accounting_receive_debit_note_create',
    section: 'accounting_expense'
  },
  {
    label: 'รับใบเพิ่มหนี้ - แก้ไข',
    value: 'accounting_receive_debit_note_edit',
    section: 'accounting_expense'
  },
  {
    label: 'ใบรวมจ่าย - ดู',
    value: 'accounting_payment_summary_view',
    section: 'accounting_expense'
  },
  {
    label: 'ใบรวมจ่าย - สร้าง',
    value: 'accounting_payment_summary_create',
    section: 'accounting_expense'
  },
  {
    label: 'ใบรวมจ่าย - แก้ไข',
    value: 'accounting_payment_summary_edit',
    section: 'accounting_expense'
  },
  {
    label: 'การเงิน - ดู',
    value: 'accounting_finance_view',
    section: 'accounting_finance'
  },
  {
    label: 'การเงิน - สร้าง',
    value: 'accounting_finance_create',
    section: 'accounting_finance'
  },
  {
    label: 'เพิ่มช่องทางการเงิน - เพิ่ม',
    value: 'accounting_finance_channel_create',
    section: 'accounting_finance'
  },
  {
    label: 'เพิ่มช่องทางการเงิน - แก้ไข',
    value: 'accounting_finance_channel_edit',
    section: 'accounting_finance'
  },
  {
    label: 'เพิ่มสำรองรับจ่าย - เพิ่ม',
    value: 'accounting_advance_fund_create',
    section: 'accounting_finance'
  },
  {
    label: 'เพิ่มสำรองรับจ่าย - แก้ไข',
    value: 'accounting_advance_fund_edit',
    section: 'accounting_finance'
  },
  {
    label: 'ผังดู',
    value: 'accounting_chart_of_accounts_view',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีรายวัน - ดู',
    value: 'accounting_journal_view',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีรายวัน - สร้าง',
    value: 'accounting_journal_create',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีรายวัน - แก้ไข',
    value: 'accounting_journal_edit',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีรายวัน - พิมพ์รายงาน',
    value: 'accounting_journal_print',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีแยกประเภท - ดู',
    value: 'accounting_ledger_view',
    section: 'accounting_general'
  },
  {
    label: 'บัญชีแยกประเภท - พิมพ์รายงาน',
    value: 'accounting_ledger_print',
    section: 'accounting_general'
  },
  {
    label: 'งบทดลอง - ดู',
    value: 'accounting_trial_balance_view',
    section: 'accounting_general'
  },
  {
    label: 'งบทดลอง - พิมพ์รายงาน',
    value: 'accounting_trial_balance_print',
    section: 'accounting_general'
  },
  {
    label: 'งบฐานะการเงิน - ดู',
    value: 'accounting_balance_sheet_view',
    section: 'accounting_general'
  },
  {
    label: 'งบฐานะการเงิน - พิมพ์รายงาน',
    value: 'accounting_balance_sheet_print',
    section: 'accounting_general'
  },
  {
    label: 'งบกำไรขาดทุน - ดู',
    value: 'accounting_income_statement_view',
    section: 'accounting_general'
  },
  {
    label: 'งบกำไรขาดทุน - พิมพ์รายงาน',
    value: 'accounting_income_statement_print',
    section: 'accounting_general'
  },
  {
    label: 'งบกระแสเงินสด - ดู',
    value: 'accounting_cash_flow_view',
    section: 'accounting_general'
  },
  {
    label: 'งบกระแสเงินสด - พิมพ์รายงาน',
    value: 'accounting_cash_flow_print',
    section: 'accounting_general'
  },
  {
    label: 'งบการเปลี่ยนแปลงผู้ถือหุ้น - ดู',
    value: 'accounting_equity_changes_view',
    section: 'accounting_general'
  },
  {
    label: 'งบการเปลี่ยนแปลงผู้ถือหุ้น - พิมพ์รายงาน',
    value: 'accounting_equity_changes_print',
    section: 'accounting_general'
  },
  {
    label: 'รายงานทางดู',
    value: 'accounting_reports_view',
    section: 'accounting_general'
  },
  {
    label: 'รายงานทางพิมพ์รายงาน',
    value: 'accounting_reports_print',
    section: 'accounting_general'
  },
  {
    label: 'DBD e-filling - ดู',
    value: 'accounting_dbd_efiling_view',
    section: 'accounting_general'
  },
  {
    label: 'Dashboard - ดู',
    value: 'inventory_dashboard_view',
    section: 'inventory'
  },
  {
    label: 'Inventory update - ดู',
    value: 'inventory_update_view',
    section: 'inventory'
  },
  {
    label: 'Inventory update - สร้าง',
    value: 'inventory_update_create',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปกติ - ดู',
    value: 'inventory_issue_normal_view',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปกติ - สร้าง',
    value: 'inventory_issue_normal_create',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปกติ - แก้ไข',
    value: 'inventory_issue_normal_edit',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปรับปรุง - ดู',
    value: 'inventory_issue_adjust_view',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปรับปรุง - สร้าง',
    value: 'inventory_issue_adjust_create',
    section: 'inventory'
  },
  {
    label: 'ตัดจ่าย - รายการปรับปรุง - แก้ไข',
    value: 'inventory_issue_adjust_edit',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปกติ - ดู',
    value: 'inventory_receive_normal_view',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปกติ - สร้าง',
    value: 'inventory_receive_normal_create',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปกติ - แก้ไข',
    value: 'inventory_receive_normal_edit',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปรับปรุง - ดู',
    value: 'inventory_receive_adjust_view',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปรับปรุง - สร้าง',
    value: 'inventory_receive_adjust_create',
    section: 'inventory'
  },
  {
    label: 'เติม - รายการปรับปรุง - แก้ไข',
    value: 'inventory_receive_adjust_edit',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปกติ - ดู',
    value: 'inventory_transfer_normal_view',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปกติ - สร้าง',
    value: 'inventory_transfer_normal_create',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปกติ - แก้ไข',
    value: 'inventory_transfer_normal_edit',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปรับปรุง - ดู',
    value: 'inventory_transfer_adjust_view',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปรับปรุง - สร้าง',
    value: 'inventory_transfer_adjust_create',
    section: 'inventory'
  },
  {
    label: 'โอน - รายการปรับปรุง - แก้ไข',
    value: 'inventory_transfer_adjust_edit',
    section: 'inventory'
  },
  {
    label: 'เพิ่มสินค้า - ดู',
    value: 'inventory_add_product_view',
    section: 'inventory'
  },
  {
    label: 'เพิ่มสินค้า - สร้าง',
    value: 'inventory_add_product_create',
    section: 'inventory'
  },
  {
    label: 'Advices - ดู',
    value: 'inventory_advices_view',
    section: 'inventory'
  },
  {
    label: 'Advices - สร้าง',
    value: 'inventory_advices_create',
    section: 'inventory'
  },
  // ใบเบิกสินค้าส่วนกลาง (REQ-005) — API ตรวจสร้าง/อนุมัติด้วย ผู้มีสิทธิ์อนุมัติเห็นใบของทุกสาขา
  {
    label: 'ใบเบิกสินค้า - ดู',
    value: 'inventory_requisition_view',
    section: 'inventory'
  },
  {
    label: 'ใบเบิกสินค้า - สร้าง (สาขา)',
    value: 'inventory_requisition_create',
    section: 'inventory'
  },
  {
    label: 'ใบเบิกสินค้า - อนุมัติ / แก้จำนวน / ยกเลิก (ส่วนกลาง)',
    value: 'inventory_requisition_approve',
    section: 'inventory'
  },
  {
    label: 'Transactions - ดู',
    value: 'inventory_transactions_view',
    section: 'inventory'
  },
  {
    label: 'Transactions - ยกเลิกเอกสาร',
    value: 'cancel_inventory_transaction_document',
    section: 'inventory'
  },
  {
    label: 'รายงาน - ดู',
    value: 'inventory_reports_view',
    section: 'inventory'
  },
  {
    label: 'Asset update - ดู',
    value: 'asset_update_view',
    section: 'asset'
  },
  {
    label: 'Asset update - สร้าง',
    value: 'asset_update_create',
    section: 'asset'
  },
  {
    label: 'โอนย้ายสินทรัพย์ระหว่างสาขา - ดู',
    value: 'asset_transfer_branch_view',
    section: 'asset'
  },
  {
    label: 'โอนย้ายสินทรัพย์ระหว่างสาขา - สร้าง',
    value: 'asset_transfer_branch_create',
    section: 'asset'
  },
  {
    label: 'แก้ไขสถานะที่ตั้ง / สถานะการใช้งาน - ดู',
    value: 'asset_edit_status_location_view',
    section: 'asset'
  },
  {
    label: 'แก้ไขสถานะที่ตั้ง / สถานะการใช้งาน - สร้าง',
    value: 'asset_edit_status_location_create',
    section: 'asset'
  },
  {
    label: 'เพิ่มทรัพย์สิน - ดู',
    value: 'asset_add_view',
    section: 'asset'
  },
  {
    label: 'เพิ่มทรัพย์สิน - สร้าง',
    value: 'asset_add_create',
    section: 'asset'
  },
  {
    label: 'รายการเคลื่อนไหว - ดู',
    value: 'asset_movement_view',
    section: 'asset'
  },
  {
    label: 'รายงานทะเบียนทรัพย์สิน - ดู',
    value: 'asset_register_report_view',
    section: 'asset'
  },
  {
    label: 'ตารางคำนวณค่าเสื่อม - ดู',
    value: 'asset_depreciation_table_view',
    section: 'asset'
  },

  {
    label: 'จัดการทันตแพทย์',
    value: 'setting_doctor',
    section: 'setting'
  },
  {
    label: 'จัดการพนักงาน',
    value: 'setting_user',
    section: 'setting'
  },
  {
    label: 'จัดการ Contype',
    value: 'setting_contype',
    section: 'setting'
  },
  {
    label: 'จัดการสิทธิ์การใช้งาน',
    value: 'setting_role',
    section: 'setting'
  },
  {
    label: 'จัดการสาขา',
    value: 'setting_branch',
    section: 'setting'
  },

  {
    label: 'จัดการรายการรักษา',
    value: 'setting_treatment_item',
    section: 'setting'
  },
  {
    label: 'จัดการ Price List',
    value: 'setting_price_list',
    section: 'setting'
  },
  {
    label: 'จัดการหมวดการรักษา',
    value: 'setting_treatment_category',
    section: 'setting'
  },
  {
    label: 'การจัดการโปรโมชั่น',
    value: 'setting_promotion',
    section: 'setting'
  },
  {
    label: 'จัดการบริษัทแล็บ',
    value: 'setting_lab_company',
    section: 'setting'
  },
  {
    label: 'เข้าถึงได้ทุกสาขา',
    value: 'switch_branch',
    section: 'setting'
  },

  {
    label: 'ดู Follow up',
    value: 'view_line_follow_up',
    section: 'line_oa'
  },
]

const usersColumns: any = (onUpdate) => ([
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='ชื่อตำแหน่ง' className='min-w-125px' />,
    accessor: 'name',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='สิทธิ์' className='min-w-125px' />,
    accessor: 'permissions',
    Cell: ({ value, row }) => row.original.isSuperAdmin ? 'All' : value?.length >= 8 ? `${value.length} สิทธ์ิ` :
      (value || []).map((item) => _.find(permissions, ['value', item])?.label || 'n/a').join(', ')
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    accessor: 'isSuperAdmin',
    Cell: ({ ...props }) => !props.value && <UserActionsCell onUpdate={onUpdate} id={props.data[props.row.index].id} />,
  },
])

export { usersColumns }
